import React, { useState } from 'react';
import { truncateHtmlContent, shouldShowMoreButton } from '../utils/helpers.js';
import { useI18n } from '../i18n/index.jsx';

const ExpandableBio = ({
  htmlContent,
  maxLength = 300,
  className = '',
  showMoreText = null,
  showLessText = null
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useI18n();

  if (!htmlContent) return null;

  const showButton = shouldShowMoreButton(htmlContent, maxLength);
  const displayContent = isExpanded || !showButton 
    ? htmlContent 
    : truncateHtmlContent(htmlContent, maxLength);

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`expandable-bio ${className}`}>
      <div 
        className="expandable-bio__content"
        dangerouslySetInnerHTML={{ __html: displayContent }}
      />
      {showButton && (
        <button 
          className="expandable-bio__toggle-btn"
          onClick={toggleExpansion}
          type="button"
        >
          {isExpanded ? showLessText || t('show_less') : showMoreText || t('show_more')}
        </button>
      )}
    </div>
  );
};

export default ExpandableBio;